import { ReactNode } from 'react';
import { Page } from '@backstage/core-components';
import styles from './EntityPageFrame.module.css';

/**
 * The scroll container of the entity page. The app shell does not scroll; a
 * `Page` fills the space below the global header (see the theme) and scrolls
 * its content, as on every other page.
 */
export const EntityPageFrame = ({ children }: { children: ReactNode }) => (
  <Page themeId="home">
    <div className={styles.content}>{children}</div>
  </Page>
);
